import { Header, SpaceBetween } from '@amzn/awsui-components-react/polaris';
import Layout from '../layout/Layout';
import AgentCardsContainer from './AgentCardsContainer';
import ToolsPanel from './ToolsPanel';

const GenAIHub = () => {
  return (
    <Layout>
      <SpaceBetween direction="vertical" size="l">
        <Header
          variant="h1"
          description="Explore and interact with Maps Data GenAI agents"
        >
          Maps Data GenAI Hub
        </Header>
        <AgentCardsContainer />
        <ToolsPanel />
      </SpaceBetween>
    </Layout>
  );
};

export default GenAIHub;
